import Head from 'next/head'
import '@/styles/globals.css'
import type { AppProps } from 'next/app'
import { ThemeProvider } from 'next-themes'
import { Toaster } from 'sonner'
import { useUserStore } from '@/store/user'
import { useConfigStore } from '@/store/config'
import { useEffect } from 'react'
import { Agentation } from 'agentation';
import { SystemScripts } from '@/components/SystemScripts'
import { wsClient } from '@/lib/ws-client'
import { WSServerMessageType } from '@/types/ws'
import type { WSBalanceUpdatedData } from '@/types/ws'

export default function App({ Component, pageProps }: AppProps) {
  const initUser = useUserStore((state) => state.init)
  const fetchConfig = useConfigStore((state) => state.fetchConfig)
  const systemConfig = useConfigStore((state) => state.config)
  const user = useUserStore((state) => state.user)
  const updateBalance = useUserStore((state) => state.updateBalance)
  const siteName = systemConfig?.site_name || 'AI漫剧平台'

  useEffect(() => {
    initUser()
    fetchConfig()
  }, [initUser, fetchConfig])

  // 全局唯一 WebSocket 连接（登录后建立，登出后断开）
  useEffect(() => {
    const token = localStorage.getItem('token')
    if (user && token) {
      wsClient.connect()
    } else if (!token) {
      wsClient.disconnect()
    }
  }, [user])

  // 监听余额更新（扣费成功后由服务端推送）
  useEffect(() => {
    if (!user) return

    const unsubscribe = wsClient.on(WSServerMessageType.BALANCE_UPDATED, (message) => {
      const data = message.data as WSBalanceUpdatedData
      if (typeof data?.balance === 'number') {
        updateBalance(data.balance)
      }
    })

    return () => unsubscribe()
  }, [user, updateBalance])

  return (
    <ThemeProvider attribute="class" defaultTheme="dark" enableSystem={false}>
      <Head>
        {/* <title>{`${siteName} - 让故事瞬间生动`}</title> */}
        <title>{`${siteName} - 专业一站式AI漫剧创作平台`}</title>
        <meta name="keywords" content="AI漫剧系统, AI视频制作系统, 自动化漫剧, 企业级AI创作平台, OEM独立运营系统, 剧本转视频系统" />
        <meta name="description" content="提供专业的AI自动化漫剧创作系统，助力企业快速搭建专属的从剧本到视频全流程AI自动化创作平台。" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Head>
      <Component {...pageProps} />
      <Toaster position="top-center" richColors />
      <SystemScripts />
      {/* {process.env.NODE_ENV === "development" && <Agentation />} */}
    </ThemeProvider>
  )
}
